"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasValue = hasValue;
// This function is a required workaround for TypeScript to recognize that undefined/null values have been filtered (e.g. from an array)
// Taken from https://github.com/microsoft/TypeScript/issues/16069
function hasValue(value) {
    return value !== undefined && value !== null;
}
//# sourceMappingURL=hasValue.js.map